<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="110px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.orderCode" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matCode" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matName" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="状态" class="EL-Form-Item">
                        <el-select v-model="mainSearch.status" clearable="clearable" @change="saveSearch()">
                            <el-option key="1" value="EXECUTE" label="进行中"></el-option>
                            <el-option key="2" value="COMPLETE" label="完成"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="clickSelectList">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="reset">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="采购入库">
                <el-button v-authority="'BACK_MENU4_M1_B1'" class="btn-t-edit" @click="isReceivingDetails = true">
                    订单同步
                </el-button>
                <el-button v-authority="'BACK_MENU4_M1_B2'" class="btn-t-edit" type="primary" @click="collect(0)">非寄售收货</el-button>
                <el-button v-authority="'BACK_MENU4_M1_B2'" class="btn-t-edit" type="primary" @click="collect(1)">寄售收货</el-button>
                <el-button v-authority="'BACK_MENU4_M1_B3'" class="btn-t-edit" type="primary" @click="openReturnGoods()">RP退货</el-button>
                <el-button v-authority="'BACK_MENU4_M1_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table v-loading="auxiStockLoading" :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getAuxiStockData" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" @selectionChange="selectAll">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column label="订单编号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="通道编号" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="订单数量" prop="orderQuan" align="center">
                </el-table-column>
                <el-table-column label="已收数量" prop="matArriveQuan" align="center">
                </el-table-column>
                <el-table-column label="剩余数量" prop="matArriveQuan" align="center">
                    <template slot-scope="scope">
                        <div>{{scope.row.orderQuan - scope.row.matArriveQuan}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="供应商" prop="supplier" align="center">
                </el-table-column>
                <el-table-column label="要求到达时间" prop="requireTime" align="center">
                </el-table-column>
                <el-table-column label="操作" min-width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU4_M1_B5'" class="btn-t-edit" @click="getOrderDeliveryIdMat(scope.row.orderCode,scope.row.matCode)">详情</el-button>
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!--收货详情-->
        <el-dialog title="收货详情" :visible.sync="insertAuxiStockDialog" class="fromDialog" :style="$popups.popups(0.8,0.9)">
            <h-table :headerCellStyle="auxiStockDetailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.74)" :data="insertAuxiData" @selectionChange="selectAuxiAll" :key="rowTableKey" >
                <!-- <el-table-column type="selection" align="center"> </el-table-column> -->
                <el-table-column label="通道" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="采购订单编号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="订单数量" prop="orderQuan" align="center">
                </el-table-column>
                <el-table-column label="已收数量" prop="matArriveQuan" align="center">
                </el-table-column>
                <el-table-column label="仓库类型" prop="saleFlagName" align="center">
                </el-table-column>
                <el-table-column label="剩余数量" prop="matArriveQuan" align="center">
                    <template slot-scope="scope">
                        <div>{{scope.row.orderQuan - scope.row.matArriveQuan}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="物料类型" prop="mtType" align="center" width="280px" v-if="fcCode=='DLM'">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.mtType" placeholder="请选择" filterable clearable="clearable" >
                            <el-option v-for="(item, index) in mtTypeList" :key="index" :label="item.ddCode+' - '+item.ddName" :value="item.ddCode">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="选择库位" prop="mtType" align="center" width="200px" >
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.lcCode" placeholder="请选择" filterable clearable="clearable" >
                            <el-option v-for="(item, index) in lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="收货数量" prop="nowQuan" align="center" width="200">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.nowQuan" size="mini" style="line-height: 26px !important" @change="handleChange"></el-input-number>
                    </template>
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button class="btn-t-info" @click="insertAuxiStockDialog = false" type="info">关 闭</el-button>
                <el-button class="btn-t-edit" :loading="insertAuxiStockMethods" @click="insertAuxiStockMethod()" type="info">收 货</el-button>
            </div>
        </el-dialog>

        <!-- 订单同步 -->
        <el-dialog title="订单同步" :visible.sync="isReceivingDetails" class="fromDialog" :style="$popups.popups(0.2,0.25)" :close-on-click-modal="false" :show-close="false" @click.stop>
            <el-form label-position="right" label-width="80px">
                <el-form-item label="采购订单" prop="tableOrderCode" class="EL-Form-Item" >
                    <el-input v-model="tableOrderCode" placeholder="请输入">
                        </el-input>
                </el-form-item>
            </el-form>
        
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="isReceivingDetails = false" class="btn-t-info">取 消</el-button>
                <el-button @click="synchronization()" class="btn-t-edit">确 认</el-button>
            </span>
        </el-dialog>


        <!-- 详情 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.8,0.9)" title="间材库入库详情" :visible.sync="auxiStockDetailDialog">
            <el-row>
                <el-col :lg="3" :xl="3" :offset="21" style="padding:10px 0">
                    <el-button @click="rePrintBarcode()" class="btn-t-edit">标签打印</el-button>
                </el-col>
            </el-row>
            <h-table :headerCellStyle="auxiStockDetailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.74)" :data="orderDeliveryIdMatList" @selectionChange="selectPrintAll">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column label="入库单号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="收货单号" prop="odCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center"></el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center"></el-table-column>
                <el-table-column label="收货数量" prop="matQuan" align="center"></el-table-column>
                <el-table-column label="订单编号" prop="orderCode" align="center"></el-table-column>
                <!-- <el-table-column label="原始批次号" prop="oldBatchNo" align="center"></el-table-column>
                <el-table-column label="新批次号" prop="newBatchNo" align="center"></el-table-column> -->
                <el-table-column label="包装箱号" prop="boxCode" align="center"></el-table-column>
                <el-table-column label="收货状态" prop="odStatus" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.odStatus == 'EXECUTE'">收货中</span>
                        <span v-if="scope.row.odStatus == 'WAITCHECK'">待检</span>
                        <span v-if="scope.row.odStatus == 'CHECKING'">检验中</span>
                        <span v-if="scope.row.odStatus == 'WAIT'">待入库</span>
                        <span v-if="scope.row.odStatus == 'INPUT'">已入库</span>
                        <span v-if="scope.row.odStatus == 'WAITRETURN'">待退货</span>
                        <span v-if="scope.row.odStatus == 'RETURNED'">已退货</span>
                    </template>
                </el-table-column>
                <el-table-column label="采购入库时间" prop="odStockTime" align="center" width="100px"></el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center"></el-table-column>
                <el-table-column label="计量单位" prop="matUnit" align="center"></el-table-column>
                <!-- <el-table-column label="物料属性" prop="matType" align="center"></el-table-column> -->
                <el-table-column label="生产日期" prop="matProduceTime" align="center" width="100px"></el-table-column>
                <el-table-column label="有效期" prop="matEffectiveTime" align="center" width="100px"></el-table-column>
                <el-table-column label="保质期" prop="matQualityTime" align="center" width="100px"></el-table-column>
                <el-table-column label="创建时间" prop="createTime" align="center" width="100px"></el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button class="btn-t-info" @click="closeAuxiStockDetailDialog" type="info">关 闭</el-button>
            </div>
        </el-dialog>

        <!-- 选择库位窗口 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.3,0.3)" title="库位" :visible.sync="whCodeDialog">
            <el-form label-position="center" label-width="90px" class="EL-Form">
                <el-col :lg="20" :xl="20" :offset="2">
                    <el-form-item label="系统推荐库位" class="EL-Form-Item">
                        <el-input el-input v-model="lcCode"> </el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button class="btn-t-info" @click="closeWarehousing()">取 消</el-button>
                <el-button class="btn-t-edit" @click="insertWarehousing()">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 交易详情 -->
        <el-dialog title="RP退货" :visible.sync="insertShowRecord" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false">
            <el-form label-position="right" label-width="100px">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="交易类型" prop="sorTypeSub" class="EL-Form-Item">
                        <el-select v-model="sorTypeSub" clearable="clearable" placeholder="请选择">
                            <el-option value="RP" label="RP"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4" :offset="15">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="rePrintBarcode()">
                            标签打印
                        </el-button>
                        <el-button class="btn-t-edit" @click="openSynchronizeItemProperties()">
                            同步物料属性
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <h-table :style="$popups.harvestRecordStyle(0.65)" :data="returnGoodsList.data" @selectionChange="selectAll">
                <el-table-column type="selection" align="center" fixed="left"></el-table-column>
                <el-table-column label="通道" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="库存数量" align="center" prop="beforeMatQuan">
                </el-table-column>
                <el-table-column label="调整数量" align="center" prop="matQuan" width="150px">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.adjustMatQuan" style="width: 100%;line-height: 26px !important" size="mini"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="批次号" align="center" prop="batchNo" width="150px">
                </el-table-column>
                <el-table-column label="库位" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.laCode || scope.row.lcCode }}
                    </template>
                </el-table-column>
                <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs" width="70px">
                </el-table-column>
                <el-table-column label="入库时间" align="center" prop="matCreateTime">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button size="mini" type="info" @click="closeDialogClick()">取 消</el-button>
                <el-button size="mini" class="btn-t-edit" @click="saveOtherOut()">确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import confluenceVue from '../reportData/confluence.vue';
    import moment from "moment";
    export default {
        name: "ConstituteDisc",
        data() {
            return {

                insertShowRecord: false, //RP退货窗口
                sorTypeSub: "RP", //交易类型
                // RP退货集合
                returnGoodsList:{
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                tableOrderCode:"",
                isReceivingDetails :false,
                auxiStockLoading: true,
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                // 筛选条件
                mainSearch: {
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    sasCode: "",
                    matCode: "",
                    matName: "",
                    status: "EXECUTE",
                    person: localStorage.getItem("user"),
                    orderCode: '',
                    whCode: localStorage.getItem("whCode") || "",
                    date: [],
                },
                //选择的物料编号
                matCode: "",
                //物料描述
                matName: "",
                //批次
                batchNo: "",
                //包装箱号
                boxBarcode: "",
                //箱号是否存在
                boxBarcodeFlag: false,
                //数量
                matQuan: "",
                //全选
                checkList: [],
                //采购窗口
                insertAuxiStockDialog: false,
                //间材库入库详情窗口
                auxiStockDetailDialog: false,
                //间材库入库编号
                sasCode: "",
                //物料集合
                materialList: [],
                //间材库类型
                whType: "20",
                //间材库库位可用集合
                lcCodes: [],
                saleFlag:"",
                //系统推荐库位
                lcCode: "",
                //库位是否可用
                lcCodeFlag: false,
                //库位窗口
                whCodeDialog: false,
                //间材库采购对象集合
                AuxiStockData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //间材库所有采购对象集合
                AuxiStockAllData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //阻盘明细对象集合
                auxiStockDetailData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //全选
                checkList: [],
                insertAuxiData: [],
                //收货集合
                insertAuxiList:[],
                //退货集合
                returnAuxiList:[],
                // 工厂编号
                fcCode: localStorage.getItem("fcCode") || "",
                //操作人
                person: localStorage.getItem("user"),
                //操作人工号
                personNumber: localStorage.getItem("empNumber"),

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                orderCode: '', //订单编号

                mtTypeList: [],
                checkAuxiList: [],
                selectPrintList: [],
                lcCodeList: [],

                downloadLoading: false, //下载中
                insertAuxiStockMethods: false,

                //间材收货详情集合
                orderDeliveryIdMatList: [],
                rowTableKey:false
            };
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.date[1]);
                        }
                    }
                }
            },
        },
        methods: {		
			handleChange(){
				this.$forceUpdate();
				this.rowTableKey = !this.rowTableKey;
			},

            closeDialogClick(){
                this.getTableData();
                this.insertShowRecord = false;
            },

            /* 获取首页的数据 */
            getTableData() {
                this.$http
                    .request({
                        url: "/api/order/getStockListMatCreateTime",
                        method: "GET",
                        params: {
                            fcCode: this.checkList[0].fcCode || null,
                            whCode: this.checkList[0].whCode || null,
                            matCode: this.checkList[0].matCode || null,
                            batchNo: this.checkList[0].batchNo || null,
                            pageNum: this.returnGoodsList.nowPage,
                            pageSize: this.returnGoodsList.pageSize,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.returnGoodsList.data = res.data.list || [];
                            this.returnGoodsList.data.forEach(ele => {
                                ele.beforeMatQuan = ele.matQuan;
                                ele.adjustMatQuan = ele.matQuan;
                            });
                            this.returnGoodsList.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    })
                    .catch((error) => {
                        this.$message.error("错误");
                    });
            },

            openReturnGoods(){
                if(this.checkList.length != 1){
                    this.$message({
                        message: "只能对一个订单进行RP退货!",
                        type: "warning",
                    });
                    return
                }
                this.getTableData();
                this.insertShowRecord = true;
            },

            /* 新增调整记录 */
            saveOtherOut() {
                if (!this.sorTypeSub) {
                    this.$message({
                        type: "warning",
                        message: "请选择交易类型",
                    });
                    return;
                }
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请选择物料记录",
                        type: "warning",
                    });
                    return;
                }
                var lengthFlag = false;

                var matQuanFlag = false;

                var barcodes = "";

                this.checkList.forEach((obj) => {
                    if(barcodes == ''){
                        barcodes = obj.boxBarcode;
                    }else{
                        barcodes += "," + obj.boxBarcode;
                    }
                });

                this.checkList.forEach((obj) => {

                    //计算调整后的数量
                    var type = this.sorTypeSub;
                    if(type == 'IA' || type == 'RW' || type == 'RP' || type == 'RI'){
                        //大于0相加的
                        obj.matQuan = obj.beforeMatQuan + obj.adjustMatQuan;
                    }else if(type == 'IW' || type == 'IS' || type == 'SS' || type == 'VR'){
                        //大于0 需要扣的
                        obj.matQuan = obj.beforeMatQuan - obj.adjustMatQuan;
                    }
                    

                    //添加操作人，操作工号
                    obj.person = localStorage.getItem('user');
                    obj.personNumber = localStorage.getItem("empNumber");

                    if (obj.newBatchNo != undefined && obj.newBatchNo.length > 10) {
                        lengthFlag = true;
                    }

                    if(isNaN(obj.adjustMatQuan) || obj.adjustMatQuan == 0){
                        matQuanFlag = true;
                    }

                    // 添加交易类型
                    obj.sorTypeSub = this.sorTypeSub;
                    // 如果为IA时判断当前新批次是否存在

                    if (
                        obj.sorTypeSub == "IA" &&
                        obj.newBatchNo != undefined &&
                        obj.newBatchNo != "" && obj.batchNo != obj.newBatchNo
                    ) {
                        obj.batchNo = obj.newBatchNo;
                    }
                });

                if (matQuanFlag) {
                    this.$message({
                        message: "请填写调整数量",
                        type: "warning",
                    });
                    return;
                }
                console.log(this.checkList);
                this.$http
                    .request({
                        url: "/api/otherRecord/saveOtherOut",
                        method: "POST",
                        showLoading: true,
                        data: this.checkList,
                        params: {
                            opearType: this.sorTypeSub,
                            barcodes: barcodes
                        }
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                title: "成功",
                                message: "调整成功！",
                                type: "success",
                            });
                            this.getAuxiStockData();
                            this.insertShowRecord = false;
                            this.logRemarks = "otherRecord：新增杂出记录成功";
                        } else {
                            this.$message.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "otherRecord：新增杂出记录失败";
                        }
                        this.saveOtherOuts = false;
                        
                        this.systemLog();
                    })
                    .catch((error) => {
                        this.saveOtherOuts = false;
                        this.$message.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            },

            synchronization(){
                if(this.tableOrderCode == "" || this.tableOrderCode.length != 7){
                    this.$message({
                        message: "请填写正确的采购编号!",
                        type: "warning",
                    });
                    return
                }

                this.$http
                    .request({
                        url: "/api/order/synchronization",
                        method: "POST",
                        showLoading: true,
                        params:{
                            orderCode:this.tableOrderCode.toUpperCase()
                        }
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.$message({
                                message: "同步成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })

            },

            selectPrintAll(val) {
                this.selectPrintList = val;
            },
            selectAuxiAll(val) {
                this.checkAuxiList = val;
            },
            collect(val) {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请选择库存记录！",
                        type: "warning",
                    });
                    return;
                }
                this.saleFlag = val ;
                var orderCode = this.checkList[0].orderCode
                var num = 0;
                this.checkList.forEach((item) => {
                    if (item.orderCode != orderCode) {
                        num += 1;
                    }
                })

                if (num != 0) {
                    this.$message({
                        message: "请选择同一个订单的库存记录！",
                        type: "warning",
                    });
                    return;
                }
                this.insertAuxiStockDialog = true;
                var orderCode = this.checkList[0].orderCode;
                var fcCode = this.checkList[0].fcCode;
                var token = this.checkList[0].token;
                //var pdId = this.checkList[0].pdId;
                let matCodeList = [];
                let pdIds = [];
                this.checkList.forEach((item) => {
                    matCodeList.push(item.matCode)
                    console.log(item.pdId);
                    pdIds.push(item.pdId);
                })
                var matCode = matCodeList.join(",");
                var pdId = pdIds.join(",");
                this.getAuxiStockDetail(orderCode, matCode, fcCode, token, pdId)

                var whCode = this.checkList[0].whCode;
                this.getAuxiMaterialData(whCode)
            },
            //复选框
            selectAll(val) {
                this.checkList = val;
            },
            //关闭入库窗口
            closeWarehousing() {
                this.whCodeDialog = false;
            },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.clickSelectList()
                }, 1000)
            },
            //入库条件
            openWarehousing() {
                if (this.checkList.length != 1) {
                    this.$message({
                        type: "warning",
                        message: "只能对一个采购单进行入库",
                    });
                } else if (this.checkList[0].status != "创建") {
                    this.$message({
                        type: "warning",
                        message: "不能对入库完成的采购单进行入库",
                    });
                } else {
                    //该库位可用，进行入库操作
                    this.$http
                        .request({
                            url: "/api/location/getLocationByCodeAndType",
                            method: "GET",
                            showLoading: true,
                            params: {
                                fcCode: this.fcCode,
                                whType: this.whType,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.lcCodes = resp.data.list;
                                this.lcCode = resp.data.list[0].lcCode;
                                this.whCodeDialog = true;
                            } else {
                                this.$message({
                                    message: resp.message,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {
                            this.$message({
                                message: "操作失败",
                                type: "warning",
                            });
                        });
                }
            },
            //进行入库
            insertWarehousing() {
                this.lcCodes.forEach((item) => {
                    if (item.lcCode == this.lcCode) {
                        this.lcCodeFlag = true;
                    }
                });
                if (!this.lcCodeFlag) {
                    this.$message({
                        type: "warning",
                        message: "该库位不可用或已被占用！",
                    });
                } else {
                    this.$http
                        .request({
                            url: "/api/auxiMaterial/insertAuxiStockWarehousing",
                            method: "POST",
                            showLoading: true,
                            params: {
                                sasCode: this.checkList[0].sasCode,
                                lcCode: this.lcCode,
                                whCode: localStorage.getItem("whCode") || "",
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$message({
                                    message: "入库成功！",
                                    type: "success",
                                });
                            }
                            this.lcCode = "";
                            this.whCodeDialog = false;
                            this.getAuxiStockData();
                        })
                        .catch((error) => {
                            this.$message({
                                message: "操作失败",
                                type: "warning",
                            });
                        });
                }
            },
            //选择物料编号的同时给定物料名称
            change(val) {
                this.matName = val.mtName;
            },
            //打开新增间材库采购窗口
            showAuxiStockDialog() {
                this.insertAuxiStockDialog = true;
                this.getMaterialAll();
            },
            //关闭新增间材库采购窗口
            closeAuxiStockDialog() {
                this.insertAuxiStockDialog = false;
                this.matCode = "";
                this.matName = "";
                this.batchNo = "";
                this.boxBarcode = "";
                this.matQuan = "";
                this.AuxiStockData.data = [];
            },
            //打开间材库入库明细窗口
            showAuxiStockDetailDialog(orderCode, matCode, fcCode, token, pdId) {
                this.auxiStockDetailDialog = true;
                this.orderCode = orderCode;
                this.getAuxiStockDetail(orderCode, matCode, fcCode, token, pdId);
            },
            //关闭间材库明细窗口
            closeAuxiStockDetailDialog() {
                this.orderDeliveryIdMatList = [];
                this.auxiStockDetailDialog = false;
            },
            //删除组盘的箱
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            //获取类型
            getmtTypeList() {
                this.$http.request({
                    url: "/api/dictData/getDictData",
                    method: "GET",
                    showLoading: true,
                    params: {
                        ddCode: "MDTYPE",
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.mtTypeList = resp.data.list || [];
                    }
                }).catch((error) => {});
            },
            /**
             * 查询所有的物料编号
             */
            getMaterialAll() {
                this.$http
                    .request({
                        url: "/api/material/getMaterialAll",
                        method: "GET",
                        params: {
                            fcCode: this.fcCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            console.log(resp.data.list);
                            this.materialList = resp.data.list;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            // 点击查询按钮 重置页号
            clickSelectList() {
                this.mainData.nowPage = 1;
                this.getAuxiStockData();
            },
            /**
             * 获取间材库入库记录
             */
            getAuxiStockData() {
                this.$http
                    .request({
                        url: "/api/order/getOrderPurchase",
                        method: "GET",
                        params: {
                            pageNum: this.mainData.nowPage, //	页号
                            pageSize: this.mainData.pageSize, //	页大小
                            fcCode: this.mainSearch.fcCode || null, //	工厂编号
                            sasCode: this.mainSearch.sasCode || null, //	间材库入库编号
                            matCode: this.mainSearch.matCode || null, //	物料编号
                            matName: this.mainSearch.matName || null, // 物料描述
                            orderStatus: this.mainSearch.status || null, //	状态
                            // person: this.mainSearch.person || null, //操作员
                            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                            //whCode: this.mainSearch.whCode || null,
                            orderCode: this.mainSearch.orderCode,
                            //wareType: '20'
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainData.data = res.data.list;
                            this.mainData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                        this.auxiStockLoading = false;
                    });
            },
            /**
             * 根据间材库入库编号查询详情
             */
            getAuxiStockDetail(orderCode, matCode, fcCode, token, pdId) {
                //根据间材库入库编号获取详细信息
                this.$http
                    .request({
                        url: "/api/order/getOrderPurchaseDetailList",
                        method: "GET",
                        params: {
                            orderCode: orderCode,
                            matCode: matCode,
                            fcCode: fcCode,
                            //token: token,
                            pdIds: pdId,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.auxiStockDetailData.data = resp.data.list;
                            for (var index in this.auxiStockDetailData.data) {
                                this.auxiStockDetailData.data[index].nowQuan = this.auxiStockDetailData.data[index].orderQuan - this.auxiStockDetailData.data[index].matArriveQuan;
                                this.auxiStockDetailData.data[index].person = this.person;
                                this.auxiStockDetailData.data[index].personNumber = this.personNumber;
                                this.auxiStockDetailData.data[index].fcCode = this.fcCode;
                                this.auxiStockDetailData.data[index].saleFlag = this.saleFlag;
                                this.auxiStockDetailData.data[index].saleFlagName = this.saleFlag == 0 ? "非寄售":"寄售";
                            }
                            this.auxiStockDetailData.total = resp.data.total;
                            this.insertAuxiData = this.auxiStockDetailData.data;
                        }

                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 订单详情——收货列表
             */
            getOrderDeliveryIdMat(orderCode, matCode) {
                this.auxiStockDetailDialog = true;
                this.$http
                    .request({
                        url: "/api/order/getOrderDeliveryIdMat",
                        method: "GET",
                        params: {
                            orderCode: orderCode || null,
                            matCode: matCode || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.list == null) {
                                this.$message({
                                    message: "暂无数据！",
                                    type: "warning",
                                });
                                return
                            } else {
                                this.orderDeliveryIdMatList = resp.data.list;
                            }

                        }
                    }).catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 采购间材库物料
             */
            submit() {
                //查询所有的间材库入库
                this.$http
                    .request({
                        url: "/api/auxiMaterial/getAuxiStockDataAll",
                        method: "GET",
                        params: {
                            fcCode: this.fcCode,
                        },
                    })
                    .then((res) => {
                        this.AuxiStockAllData.data = res.data.list;
                        this.AuxiStockAllData.data.forEach((item) => {
                            if (this.boxBarcode != "" && this.boxBarcode == item.boxBarcode) {
                                this.boxBarcodeFlag = true;
                            }
                        });
                        this.systemLog();
                    });
                this.AuxiStockData.data.forEach((item) => {
                    if (this.boxBarcode != "" && this.boxBarcode == item.boxBarcode) {
                        this.boxBarcodeFlag = true;
                    }
                });

                if (this.matCode == "") {
                    this.$message({
                        message: "请选择采购的物料编号！",
                        type: "warning",
                    });
                    return;
                } else if (this.batchNo == "") {
                    this.$message({
                        message: "请输入批次号！",
                        type: "warning",
                    });
                    return;
                } else if (this.boxBarcodeFlag) {
                    this.$message({
                        message: "该包装箱号已存在！",
                        type: "warning",
                    });
                    return;
                } else if (this.matQuan == "") {
                    this.$message({
                        message: "请输入采购数量！",
                        type: "warning",
                    });
                    return;
                } else {
                    var obj = {};
                    obj.fcCode = this.fcCode;
                    obj.matCode = this.matCode;
                    obj.matName = this.matName;
                    obj.matQuan = this.matQuan;
                    obj.batchNo = this.batchNo;
                    obj.boxBarcode = this.boxBarcode;
                    obj.status = "创建";
                    obj.person = this.person;
                    obj.personNumber = this.personNumber;
                    this.AuxiStockData.data.push(obj);
                    this.matCode = "";
                    this.batchNo = "";
                    this.boxBarcode = "";
                    this.matQuan = "";
                }
            },

            //标签打印
            rePrintBarcode() {
                if (this.selectPrintList.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    //打印库存标签
                    this.selectPrintList.forEach((item) => {
                        // let od = this.orderData.data.find(o => o.orderCode == item.orderCode);
                        var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                        // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                        // item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                        // "/" + produceTime + "/";

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                            item.matCode + "," + item.matQuan + "," + item.matSpecs +
                            "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                        if (item.matSpecs == undefined) {
                            item.matSpecs = "";
                        }

                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: item.boxBarcode,
                            prodCode: item.matCode,
                            prodName: item.matName,
                            batchNo: item.batchNo,
                            count: item.matQuan,
                            checkPerson: localStorage.getItem("empNumber"),
                            date: produceTime,
                            poCode: item.orderCode,
                            matSpecs: item.matSpecs,
                            whCode: item.whCode,
                            qrCode: qrCode,
                            supply: "",
                            printTime: printTime
                        }

                        this.$printer.printWMSIndirBarcode(barcodeData);
                    })

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = null
                    }, 5000)
                }
            },
            
            /**
             * 判断是收货还是退货
             */
            judgeReceipt(){
                var oneFlag = false;
                var twoFlag = false;
                var threeFlag = false;
                var zoreFlag = false;
                this.insertAuxiData.forEach((item)=>{
                    if(item.nowQuan == 0 ){
                        zoreFlag = true;   
                    }else if(item.nowQuan > 0){
                        oneFlag = true;
                        threeFlag = true;
                    }else{
                        twoFlag = true;
                    }
                })
                if(oneFlag == twoFlag){
                    this.$message({
                        message: "收货数量需全正或者全负！",
                        type: "warning",
                    });
                    return             
                }else if(zoreFlag){
                    this.$message({
                        message: "收货数量不能为0",
                        type: "warning",
                    });
                    return              
                }else if(oneFlag != twoFlag && threeFlag){
                    this.insertAuxiStockMethod();
                }else if(oneFlag != twoFlag && !threeFlag){
                    this.saveOtherIn();
                }
            },

            /**
             * 间材退货
             */
            saveOtherIn() {
                this.insertAuxiData.forEach((item) => {
                    if (item.mtType == undefined) {
                         this.$message({
                            message: "物料类型不能为空！",
                            type: "warning",
                        });
                        return
                    }
                    item.matQuan = item.nowQuan;
                    item.sorTypeSub = "20";
                    item.batchNo = item.orderCode;
                })
                this.insertAuxiStockMethods = true;
                this.$confirm("是否确认退货?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.$http.request({
                        url: "/api/otherRecord/saveOtherIn",
                        method: "POST",
                        showLoading: true,
                        data: this.insertAuxiData,
                    }).then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            // this.insertAuxiData = [];
                            this.insertAuxiStockDialog = false;
                            this.getAuxiStockData();
                            this.logRemarks = "otherRecord：新增杂入记录成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "otherRecord：新增杂入记录失败";
                        }
                        this.insertAuxiStockMethods = false;
                        this.logContent = JSON.stringify(this.insertAuxiData);
                        this.systemLog();
                    }).catch((error) => {
                        this.insertAuxiStockMethods = false;
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
                }).catch(() => {
                    this.insertAuxiStockMethods = false;
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
            },

            /**
             * 收货
             */
            insertAuxiStockMethod() {
                // if (this.checkAuxiList.length == 0) {
                //     this.$message({
                //         message: "请选择收货记录！",
                //         type: "warning",
                //     });
                //     return
                // }
                let mtType = 0;
                let lcCode = 0;
                this.insertAuxiData.forEach((item) => {
                    if (item.mtType == undefined) {
                        mtType += 1;
                    }
										
                    if (item.lcCode == undefined) {
                        lcCode += 1;
                    }
                })
								// DLM 的根据前两位默认类型 ，DLN手动选择库位。
                if (this.fcCode=='DLM' && mtType != 0) {
                    this.$message({
                        message: "物料类型不能为空！",
                        type: "warning",
                    });
                    return
                }
                if ( lcCode != 0) {
                    this.$message({
                        message: "货位不能为空！",
                        type: "warning",
                    });
                    return
                }
                this.insertAuxiStockMethods = true;
                this.$confirm("确认收货吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/insertAuxiStock",
                                method: "POST",
                                showLoading: true,
                                data: this.insertAuxiData,
                            })
                            .then((res) => {
                                this.logContent = "间材库收货";
                                if (res.status == 100) {
                                    this.insertAuxiStockDialog = false;
                                    this.$message({
                                        message: "采购成功!",
                                        type: "success",
                                    });

                                    //打印库存标签
                                    res.data.list.forEach((item) => {
                                        // let od = this.orderData.data.find(o => o.orderCode == item.orderCode);
                                        var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

                                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                        // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                                        //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                                        //     "/" + produceTime + "/";

                                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                        var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                                            item.matCode + "," + item.matQuan + "," + item.matSpecs +
                                            "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                                        if (item.matSpecs == undefined) {
                                            item.matSpecs = "";
                                        }

                                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                        var barcodeData = {
                                            boxBarcode: item.boxBarcode,
                                            prodCode: item.matCode,
                                            prodName: item.matName,
                                            batchNo: item.batchNo,
                                            count: item.matQuan,
                                            checkPerson: localStorage.getItem("empNumber"),
                                            date: produceTime,
                                            poCode: item.orderCode,
                                            matSpecs: item.matSpecs,
                                            whCode: item.whCode,
                                            qrCode: qrCode,
                                            supply: "",
                                            printTime: printTime
                                        }

                                        this.$printer.printWMSIndirBarcode(barcodeData);
                                    })

                                    this.logRemarks = "stockGroup：采购成功";
                                    this.getAuxiStockData();
                                } else {
                                    this.$message.error(res.message);
                                    this.logRemarks = "stockGroup：采购失败";
                                }
                                this.insertAuxiStockMethods = false;
                                this.systemLog();
                            });
                    })
                    .catch(() => {
                        this.insertAuxiStockMethods = false;
                        this.$message({
                            type: "info",
                            message: "已取消间材库采购",
                        });
                    });

            },
            /**
             * 重置
             */
            reset() {
                this.mainSearch = {
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    sasCode: "",
                    matCode: "",
                    matName: "",
                    status: "EXECUTE",
                    person: localStorage.getItem("user"),
                    orderCode: '',
                    whCode: localStorage.getItem("whCode") || "",
                    date: [],
                };
                this.clickSelectList();
            },
            //获取数据
            getAuxiMaterialData(whCode) {
                this.$http
                    .request({
                        url: "/api/location/getLocationAll",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            //whCode: whCode || "",
                            lcStatus: 'NORMAL',
                            lcType: 'AD,FLOOR',
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.lcCodeList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    fcCode: this.mainSearch.fcCode || null, //	工厂编号
                    sasCode: this.mainSearch.sasCode || null, //	间材库入库编号
                    matCode: this.mainSearch.matCode || null, //	物料编号
                    matName: this.mainSearch.matName || null, // 物料描述
                    orderStatus: this.mainSearch.status || null, //	状态
                    // person: this.mainSearch.person || null, //操作员
                    beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                    endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                    //whCode: this.mainSearch.whCode || null,
                    orderCode: this.mainSearch.orderCode,
                    //wareType: '20',
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/order/getOrderPurchase',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.orderStatus == 'EXECUTE') {
                            c['orderStatus'] = '进行中'
                        } else if (c.orderStatus == 'CLOSE') {
                            c['orderStatus'] = '关闭'
                        } else if (c.orderStatus == 'COMPLETE') {
                            c['orderStatus'] = '完成'
                        }

                        c.orderReturnQuan = c.orderQuan - c.matArriveQuan
                    })
                    const tHeader = ['订单编号', '物料编号', '物料描述', '订单数量', '已收数量', '剩余数量', '供应商', '要求到达时间']
                    const filterVal = ['orderCode', 'matCode', 'matName', 'orderQuan', 'matArriveQuan', 'orderReturnQuan', 'supplier', 'requireTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '采购入库单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory：导出采购入库记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "采购入库",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated() {
            /* 获取首页的数据 */
            this.auxiStockLoading = false;
            this.getmtTypeList();
          this.getAuxiStockData();
        },
    };
</script>

<style>
.h-table table tbody td .selectUp.el-select .el-input {
    width: 280px;
}
</style>